import * as moment from 'moment';

let lastProcessedUrl = '';

export function clearCampaignData(saveUTMData) {
  localStorage.removeItem('utm_source')
  localStorage.removeItem('utm_medium')
  if (!saveUTMData) {
    localStorage.removeItem('utm_source2')
    localStorage.removeItem('utm_source3')
    localStorage.removeItem('utm_medium2')
    localStorage.removeItem('utm_medium3')
  }
  localStorage.removeItem('utm_campaign')
  localStorage.removeItem('utm_content')
  localStorage.removeItem('dclid')
  localStorage.removeItem('mAutoCampaign')
  localStorage.removeItem('mAutoGCLID')
  localStorage.removeItem('mAutoclick_id')
}

export function clearEmptyCampaignData() {

  const allowedParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'dclid', 'kampania', 'gclid', 'click_id','mAutoCampaign','mAutoGCLID','mAutoclick_id'];
  let urlParams =
    window.location.search[0] === "?"
      ? window.location.search.slice(1)
      : window.location.search;
  const currentUrl = window.location.search;
  if (currentUrl === lastProcessedUrl) {
    return;
  }
  lastProcessedUrl = currentUrl;
  if (!urlParams || !allowedParams.some(param => urlParams.includes(param))) {
    return;
  }
  
  const previousSource = localStorage.getItem('utm_source');
  const source2 = localStorage.getItem('utm_source2');
  const previousMedium = localStorage.getItem('utm_medium');
  const medium2 = localStorage.getItem('utm_medium2');
  
  clearCampaignData(true);
  
  // eslint-disable-next-line no-undef
  let parsedParams = new URLSearchParams(urlParams);
  let tempObj = {};
  for (let obj of parsedParams) {
    tempObj[obj[0]] = obj[1];
  }

  if (previousSource && (tempObj.utm_source || tempObj.utm_medium || tempObj.utm_campaign || tempObj.utm_content)) {
    if (source2) {
      localStorage.setItem('utm_source3', source2);
    }
    localStorage.setItem('utm_source2', previousSource);
  }
  
  if (tempObj.utm_source) {
    localStorage.setItem('utm_source', tempObj.utm_source);
  }
  
  if (previousMedium && (tempObj.utm_source || tempObj.utm_medium || tempObj.utm_campaign || tempObj.utm_content)) {
    if (medium2) {
      localStorage.setItem('utm_medium3', medium2);
    }
    localStorage.setItem('utm_medium2', previousMedium);
  }
  
  if (tempObj.utm_medium) {
    localStorage.setItem('utm_medium', tempObj.utm_medium);
  }
  if (tempObj.utm_campaign) {
    localStorage.setItem('utm_campaign', tempObj.utm_campaign);
  } else {
    localStorage.removeItem('utm_campaign');
  }
  if (tempObj.utm_content) {
    localStorage.setItem('utm_content', tempObj.utm_content);
  } else {
    localStorage.removeItem('utm_content');
  }
  if (tempObj.dclid) {
    localStorage.setItem('dclid', tempObj.dclid);
  } else {
    localStorage.removeItem('dclid');
  }
  if (tempObj.kampania) {
    localStorage.setItem('mAutoCampaign', tempObj.kampania);
  } else {
    localStorage.removeItem('mAutoCampaign');
  }
  if (tempObj.gclid) {
    localStorage.setItem('mAutoGCLID', tempObj.gclid);
  } else {
    localStorage.removeItem('mAutoGCLID');
  }
  if (tempObj.click_id) {
    localStorage.setItem('mAutoclick_id', tempObj.click_id);
  } else {
    localStorage.removeItem('mAutoclick_id');
  }
  
  if (
    tempObj.utm_source ||
    tempObj.utm_medium ||
    tempObj.utm_campaign ||
    tempObj.utm_content ||
    tempObj.dclid ||
    tempObj.kampania ||
    tempObj.gclid ||
    tempObj.click_id
  ) {
    localStorage.setItem("mAutoCampaignCreationDate", moment().toISOString());
  }
}

export function setCampaignData() {
  let urlParams =
    window.location.search[0] === "?"
      ? window.location.search.slice(1)
      : window.location.search;
  if (urlParams) {
    const currentUrl = window.location.search;
    if (currentUrl === lastProcessedUrl) {
      return;
    }
    lastProcessedUrl = currentUrl;

    // eslint-disable-next-line no-undef
    let parsedParams = new URLSearchParams(urlParams);
    let tempObj = {};
    for (let obj of parsedParams) {
      tempObj[obj[0]] = obj[1];
    }

    const previousSource = localStorage.getItem('utm_source');
    const source2 = localStorage.getItem('utm_source2');
    
    if (previousSource && (tempObj.utm_source || tempObj.utm_medium || tempObj.utm_campaign || tempObj.utm_content)) {
      if (source2) {
        localStorage.setItem('utm_source3', source2);
      }
      localStorage.setItem('utm_source2', previousSource);
    }
    
    if (tempObj.utm_source) {
      localStorage.setItem('utm_source', tempObj.utm_source);
    }
    
    const previousMedium = localStorage.getItem('utm_medium');
    const medium2 = localStorage.getItem('utm_medium2');
    
    if (previousMedium && (tempObj.utm_source || tempObj.utm_medium || tempObj.utm_campaign || tempObj.utm_content)) {
      if (medium2) {
        localStorage.setItem('utm_medium3', medium2);
      }
      localStorage.setItem('utm_medium2', previousMedium);
    }
    
    if (tempObj.utm_medium) {
      localStorage.setItem('utm_medium', tempObj.utm_medium);
    }
    if (tempObj.utm_campaign) {
      localStorage.setItem('utm_campaign', tempObj.utm_campaign)
    }
    if (tempObj.utm_content) {
      localStorage.setItem('utm_content', tempObj.utm_content)
    }
    if (tempObj.dclid) {
      localStorage.setItem('dclid', tempObj.dclid)
    }
    if (tempObj.kampania) {
      localStorage.setItem('mAutoCampaign', tempObj.kampania)
    }
    if (tempObj.gclid) {
      localStorage.setItem('mAutoGCLID', tempObj.gclid)
    }
    if (tempObj.click_id) {
      localStorage.setItem('mAutoclick_id', tempObj.click_id)
    }
      if (
        tempObj.utm_source ||
        tempObj.utm_medium ||
        tempObj.utm_campaign ||
        tempObj.utm_content ||
        tempObj.dclid||
        tempObj.kampania ||
        tempObj.gclid ||
        tempObj.click_id
      ) {
        localStorage.setItem("mAutoCampaignCreationDate", moment().toISOString());
      }
  }
}

export function setCampaignFormSentData() {
  if (localStorage.getItem('mAutoCampaign')) {
    localStorage.setItem('mAutoFormDate', moment().toISOString());
  }
}

export function setCampaignFormSentAuctionId(auctionId) {
  if (localStorage.getItem('mAutoCampaign')) {
    localStorage.setItem('mAutoFormAuctionId', auctionId || '');
  }
}

export function checkCampaignExpirationDate() {
  let isoString = localStorage.getItem('mAutoCampaignCreationDate');
  if (isoString) {
    let parsedData = moment(isoString);
    if (parsedData.add(2, 'hours').isBefore(moment())) {
      clearCampaignData();
    }
  } else {
    clearCampaignData();
  }
}

export function deleteCampaignData() {
  if (localStorage.getItem("mAutoCampaign")) {
    localStorage.removeItem("mAutoCampaign");
  }

  if (localStorage.getItem("mAutoDCLID")) {
    localStorage.removeItem("mAutoDCLID");
  }

  if (localStorage.getItem("mAutoGCLID")) {
    localStorage.removeItem("mAutoGCLID");
  }

  if (localStorage.getItem("mAutoclick_id")) {
    localStorage.removeItem("mAutoclick_id");
  }

  if (localStorage.getItem("mAutoFormAuctionId")) {
    localStorage.removeItem("mAutoFormAuctionId");
  }

  if (localStorage.getItem("mAutoFormDate")) {
    localStorage.removeItem("mAutoFormDate");
  }

  if (localStorage.getItem("mAutoCampaignCreationDate")) {
    localStorage.removeItem("mAutoCampaignCreationDate");
  }
}
